import { IonIcon } from '@ionic/react';
import classNames from 'classnames';
import { arrowForward } from 'ionicons/icons';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { isRebillStripePlanId } from '@/constants/plans';
import { WebSubscriptionPlanConfigType } from '@/modules/subscriptions';

import {
  SubscriptionFullPaymentInfoStyles,
  SubscriptionPerDayPaymentInfoStyles,
} from './SubscriptionData.styles';

export const StripeSubscriptionData: React.FC<{
  plan: WebSubscriptionPlanConfigType;
  planId: string;
  soldOut?: boolean;
  renderDiscount?: boolean;
}> = ({ plan, planId, soldOut, renderDiscount = true }) => {
  const useRebillLabels = isRebillStripePlanId(planId);

  return (
    <>
      <SubscriptionFullPaymentInfoStyles
        className={classNames({
          soldOut,
        })}
      >
        <UiTypography className="type-label" variant="title-small">
          {useRebillLabels ? plan.displayRebill : plan.display}
          {soldOut && <span>sold out</span>}
        </UiTypography>
        <UiTypography className="local-full-prices" variant="body-small">
          {renderDiscount && (
            <>
              <UiTypography
                className="local-full-prices-without-sale"
                variant="body-small"
                color="neutral-black"
                component="span"
              >
                ${plan.basePriceWithoutSale}
              </UiTypography>
              <IonIcon icon={arrowForward} />
            </>
          )}
          ${plan.basePrice}
        </UiTypography>
      </SubscriptionFullPaymentInfoStyles>

      <SubscriptionPerDayPaymentInfoStyles
        className={classNames({
          soldOut,
        })}
      >
        {renderDiscount && (
          <UiTypography
            variant="label-medium"
            color="neutral-black"
            className="local-without-sale"
          >
            ${plan.basePricePerDayWithoutSale}
          </UiTypography>
        )}
        <UiTypography
          variant="title-small"
          color="black"
          className="local-base"
        >
          ${plan.basePricePerDay}
        </UiTypography>
        <UiTypography variant="label-medium" color="neutral-black">
          per day
        </UiTypography>
      </SubscriptionPerDayPaymentInfoStyles>
    </>
  );
};
